import { Toast, useToast, ToastProps } from "@oysterhr/ui"

interface DispatchToastProps {
  title?: string
  message?: string
  toastProps?: Omit<ToastProps, "children">
}

export const useDispatchToast = ({ superTitle }: { superTitle?: string } = {}) => {
  const toast = useToast()

  return ({ title, message, toastProps }: DispatchToastProps) => {
    toast({
      render: (
        <Toast {...toastProps}>
          <Toast.Title>{superTitle || title || ""}</Toast.Title>
          <Toast.Content>{message || ""}</Toast.Content>
        </Toast>
      ),
    })
  }
}
